var amdi18n={"__root":{"no_cloud_identity_available":"There is no CloudID available, please click next to create one.","approval_checkbox":"I agree","cloud_identity_not_usable":"Your CloudID is not usable for this service, please click next to create a new one.","delete_cloud_identity":"This will delete your current CloudID and you'll be able to create a new one.","resolve_identity":"Resolve CloudID issue"},"__de":{"no_cloud_identity_available":"Es ist keine CloudID vorhanden, bitte klicken Sie auf weiter um eine zu erstellen.","approval_checkbox":"Ich bin einverstanden","cloud_identity_not_usable":"Ihre aktuelle CloudID ist für diesen Service nicht ausreichend, bitte klicken Sie auf weiter um eine neue zu erstellen.","delete_cloud_identity":"Es wird nun ihre aktuelle CloudID entfernt, damit Sie eine neue erstellen können.","resolve_identity":"CloudID-Problem lösen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/ResolveCloudIDState_strings.js
// module id = 359
// module chunks = 3